const forseti = {
  C001TiposEstatusDeLaAudiencia: 'Forseti/Catalogos/GetTiposEstatusDeLaAudiencia',
  C005TiposMarcadores: 'Forseti/Catalogos/GetTiposMarcadores',
  C007TiposCamaras: 'Forseti/Catalogos/GetTiposCamaras',
  C011Camaras: 'Forseti/Catalogos/GetCamaras',
  C015TiposDistorsionesDeAudio: 'Forseti/Catalogos/GetTiposDeDistorsionesDeAudio'
};

export default forseti;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/forseti/catalogos/forseti.js
// module id = null
// module chunks = 